import React from 'react'

export const PointerCircle = ({hex}) => {
  return (
    <div className="color-picker-pointer-circle" style={{background:hex}}></div>
  )
}

export default PointerCircle
